import * as React from 'react';
import { mxStrings } from 'utils/JobCollabStrings';
import { jobStore } from 'utils/MobxDataManager/singletons';
import './gradeRangeVisual.scss';

interface GradeRangeVisualProps {
    gradeMinimum?: number;
    gradeMidpoint?: number;
    gradeMaximum?: number;
    currency?: string;
    structureHourly?: boolean;
}

const GradeRangeVisual = (props: GradeRangeVisualProps): JSX.Element => {
    let {
        gradeMinimum,
        gradeMidpoint,
        gradeMaximum } = props;
    const { currency, structureHourly } = props;

    let validData = true;
    if (!gradeMinimum || !gradeMidpoint || !gradeMaximum) {
        gradeMinimum = 0;
        gradeMidpoint = 1;
        gradeMaximum = 2;
        validData = false;
    }

    const minimumVal  = validData ?
        <>
            {jobStore.formatRangeValue(gradeMinimum, currency)}
        </> :
        null;
    const maximumVal = validData ?
        <>
            {jobStore.formatRangeValue(gradeMaximum, currency)}
        </> :
        null;

    let barSizeBelow50th = Math.max(0, gradeMidpoint - gradeMinimum);
    const barSizeAbove50th = Math.max(0, gradeMaximum - gradeMidpoint);

    // PSP-15539: handle case of empty/negative range, just showing single solid bar
    let hideSpacer = false;
    if (barSizeBelow50th === 0 || barSizeAbove50th === 0) {
        hideSpacer = true;
    }
    if (barSizeAbove50th === 0 && barSizeAbove50th === 0) {
        // pick one to show full bar
        barSizeBelow50th = 1;
    }

    return (
        <div className={`grade-range-viz ${validData ? '' : 'invalid'}`}>
            <div className="viz-bars">
                <div className="range-bar lower-fiftieth" style={{flexGrow: barSizeBelow50th}}/>
                { !hideSpacer && <div className="range-bar spacer" /> }
                <div className="range-bar upper-fiftieth" style={{flexGrow: barSizeAbove50th}}/>
            </div>
            {validData && <div className="viz-values">
                <div className="range-val lower">
                    <span>
                        <>
                            <span>{minimumVal}</span>
                            { structureHourly ? mxStrings.perHour : '' }
                        </>
                    </span>
                </div>
                <div className="range-val upper">
                    <span>
                        <>
                            <span>{maximumVal}</span>
                            { structureHourly ? mxStrings.perHour : '' }
                        </>
                    </span>
                </div>
            </div>}
            {!validData && <span className="market-range-no-data-msg">{mxStrings.noPayRange}</span>}
        </div>
    );
};

export { GradeRangeVisual };
export default GradeRangeVisual;
